"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = require("../../config");
var constants_1 = require("../constants");
var STRATEGIES_CACHE_KEY = 'ai-hub:strategies-config-cache';
/**
 * Lightweight shape check for the `GET /ai/strategies` payload. Anything
 * that is not an object exposing a `strategies` array is treated as a
 * malformed response so the editor can surface a load-error banner
 * instead of silently rendering an empty state.
 */
var isConfigurationShape = function (value) {
    if (!value || typeof value !== 'object')
        return false;
    return Array.isArray(value.strategies);
};
var isDbStrategyArrayShape = function (value) {
    if (!Array.isArray(value))
        return false;
    return value.every(function (candidate) {
        if (!candidate || typeof candidate !== 'object')
            return false;
        var strategy = candidate;
        return (typeof strategy.id === 'number' &&
            typeof strategy.name === 'string' &&
            Array.isArray(strategy.columns) &&
            Array.isArray(strategy.links));
    });
};
var EDGE_WEIGHT_ORDER = ['low', 'medium', 'high', 'very-high'];
var toEdgeWeightType = function (value) {
    return EDGE_WEIGHT_ORDER.reduce(function (closest, nextType) {
        var closestDelta = Math.abs(constants_1.EDGE_WEIGHT_VALUES[closest] - value);
        var nextDelta = Math.abs(constants_1.EDGE_WEIGHT_VALUES[nextType] - value);
        return nextDelta < closestDelta ? nextType : closest;
    }, 'medium');
};
var mapDbStrategiesToConfiguration = function (strategies) {
    return {
        changeHistory: null,
        strategies: strategies.map(function (strategy) {
            var edgesByNodeId = new Map();
            strategy.links.forEach(function (link) {
                var _a;
                var sourceId = String(link.fromItemId);
                var targetId = String(link.toItemId);
                var sourceEdges = (_a = edgesByNodeId.get(sourceId)) !== null && _a !== void 0 ? _a : {};
                sourceEdges[targetId] = toEdgeWeightType(Number(link.linkValue));
                edgesByNodeId.set(sourceId, sourceEdges);
            });
            var sortedColumns = __spreadArrays(strategy.columns).sort(function (left, right) { return Number(left.orderNumber) - Number(right.orderNumber); });
            var structure = sortedColumns.map(function (column) {
                var _a;
                return ({
                    id: String(column.id),
                    name: column.name,
                    nodes: ((_a = column.items) !== null && _a !== void 0 ? _a : []).map(function (item) {
                        var _a;
                        return ({
                            id: String(item.id),
                            name: item.name,
                            edges: (_a = edgesByNodeId.get(String(item.id))) !== null && _a !== void 0 ? _a : {},
                        });
                    }),
                });
            });
            return {
                id: strategy.id,
                name: strategy.name,
                structure: structure,
            };
        }),
    };
};
var readStrategiesCache = function () {
    try {
        var cached = window.localStorage.getItem(STRATEGIES_CACHE_KEY);
        if (!cached) {
            return null;
        }
        var parsed = JSON.parse(cached);
        if (isConfigurationShape(parsed)) {
            return parsed;
        }
    }
    catch (_a) {
        // Ignore cache errors; network path remains the source of truth.
    }
    return null;
};
var writeStrategiesCache = function (config) {
    try {
        window.localStorage.setItem(STRATEGIES_CACHE_KEY, JSON.stringify(config));
    }
    catch (_a) {
        // Ignore storage failures (private mode / quota), do not fail request.
    }
};
/**
 * The portal's `apiGet`/`apiPost` helpers swallow axios rejections and
 * resolve with `[]` (empty array) when the underlying HTTP call failed
 * (network abort, non-2xx status, non-JSON payload). Any payload of that
 * exact shape is therefore treated as a transport-level failure rather
 * than an invalid response body.
 */
var isTransportFailureSentinel = function (value) {
    if (value === undefined || value === null)
        return true;
    return Array.isArray(value) && value.length === 0;
};
/**
 * Reduce an axios-like / Error to a safe shape suitable for `console.error`.
 * Strips `config.headers` (which carries the `Authorization: Bearer ...`
 * value), request bodies and other potentially sensitive fields so we never
 * spill credentials to the browser console / log shippers.
 */
var toLoggableError = function (error) {
    var _a, _b;
    if (!error || typeof error !== 'object') {
        return error;
    }
    var err = error;
    return {
        name: err.name,
        message: err.message,
        code: err.code,
        status: (_a = err.response) === null || _a === void 0 ? void 0 : _a.status,
        statusText: (_b = err.response) === null || _b === void 0 ? void 0 : _b.statusText,
    };
};
/**
 * Strategy API Service
 *
 * Handles all API calls related to AI Hub Strategies.
 * Uses unified configuration endpoint pattern.
 */
var strategyApiService = {
    /**
     * Get the current strategies object.
     *
     * The portal's `apiGet` swallows axios rejections and resolves with
     * `undefined` on transport errors (network abort, 4xx/5xx, non-JSON
     * payloads). Treat both `undefined` and any payload that does not match
     * the strategies-configuration schema as a load failure so the UI can
     * surface a sanitized error banner instead of silently rendering an
     * empty editor.
     */
    getConfiguration: function () { return __awaiter(void 0, void 0, void 0, function () {
        var apiGet, result, cached, mapped, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    apiGet = config_1.getApiGet();
                    return [4 /*yield*/, apiGet('/ai/strategies')];
                case 1:
                    result = _a.sent();
                    if (!isTransportFailureSentinel(result)) return [3 /*break*/, 3];
                    return [4 /*yield*/, apiGet('/ai/strategies')];
                case 2:
                    result = _a.sent();
                    _a.label = 3;
                case 3:
                    if (isTransportFailureSentinel(result)) {
                        cached = readStrategiesCache();
                        if (cached) {
                            return [2 /*return*/, cached];
                        }
                        throw new Error('Failed to load strategies from API');
                    }
                    if (isDbStrategyArrayShape(result)) {
                        mapped = mapDbStrategiesToConfiguration(result);
                        writeStrategiesCache(mapped);
                        return [2 /*return*/, mapped];
                    }
                    if (!isConfigurationShape(result)) {
                        throw new Error('Strategies endpoint returned an unrecognised payload shape');
                    }
                    writeStrategiesCache(result);
                    return [2 /*return*/, result];
                case 4:
                    error_1 = _a.sent();
                    console.error('Error fetching strategies configuration:', toLoggableError(error_1));
                    throw error_1;
                case 5: return [2 /*return*/];
            }
        });
    }); },
    /**
     * Create a new strategies object version.
     *
     * Mirrors the {@link getConfiguration} validation: rejects an undefined
     * payload (transport error) or a body that does not match the
     * configuration schema, so the editor can surface the
     * `INVALID_RESPONSE_MESSAGE` banner instead of crashing while
     * dereferencing `result.strategies` further down the pipeline.
     */
    saveConfiguration: function (config) { return __awaiter(void 0, void 0, void 0, function () {
        var apiPost, result, err, error_2, errorData;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    apiPost = config_1.getApiPost();
                    return [4 /*yield*/, apiPost('/ai/strategies', {
                            strategies: config.strategies,
                            changeHistory: config.changeHistory,
                            createdAt: config.createdAt,
                        })];
                case 1:
                    result = _c.sent();
                    if (isTransportFailureSentinel(result)) {
                        throw new Error('Strategies save endpoint returned no payload');
                    }
                    if (!isConfigurationShape(result)) {
                        err = new Error('Strategies save endpoint returned an unrecognised payload shape');
                        err.isInvalidResponse = true;
                        throw err;
                    }
                    return [2 /*return*/, result];
                case 2:
                    error_2 = _c.sent();
                    if (((_b = (_a = error_2) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.status) === 409) {
                        errorData = error_2.response.data;
                        throw new Error(errorData.error || 'Conflict: A newer version exists. Please refresh.');
                    }
                    console.error('Error saving strategies configuration:', toLoggableError(error_2));
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    }); },
    /**
     * Get ALL change history from ALL configuration records.
     */
    getAllHistoricalChangeHistory: function () { return __awaiter(void 0, void 0, void 0, function () {
        var apiGet, result, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    apiGet = config_1.getApiGet();
                    return [4 /*yield*/, apiGet('/ai/strategies/history')];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result || []];
                case 2:
                    error_3 = _a.sent();
                    console.error('Error fetching all historical change history:', toLoggableError(error_3));
                    throw error_3;
                case 3: return [2 /*return*/];
            }
        });
    }); },
    /**
     * Get use case alignment (extended graph: Strategy -> Metrics -> Use Case),
     * including the `affectedNodes` scores contributed by this use case.
     */
    getUseCaseAlignment: function (workflowId, strategyId, useCaseId) { return __awaiter(void 0, void 0, void 0, function () {
        var apiGet, result, error_4, axiosLikeError;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    apiGet = config_1.getApiGet();
                    return [4 /*yield*/, apiGet("/ai/" + encodeURIComponent(workflowId) + "/strategies/" + encodeURIComponent(strategyId) + "/alignment/" + encodeURIComponent(useCaseId))];
                case 1:
                    result = _c.sent();
                    if (isTransportFailureSentinel(result)) {
                        throw new Error('Failed to generate alignment. Please try again.');
                    }
                    if (!result) {
                        throw new Error('No alignment data returned');
                    }
                    if (result.error) {
                        throw new Error(result.message || 'Failed to generate alignment. Please try again.');
                    }
                    if (!Array.isArray(result.structure)) {
                        throw new Error('The selected strategy structure does not have any elements. First add elements in Strategy Builder.');
                    }
                    return [2 /*return*/, result];
                case 2:
                    error_4 = _c.sent();
                    console.error("Error fetching use case alignment for strategy " + strategyId + " and use case " + useCaseId + ":", toLoggableError(error_4));
                    axiosLikeError = error_4;
                    if ((_b = (_a = axiosLikeError === null || axiosLikeError === void 0 ? void 0 : axiosLikeError.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) {
                        throw new Error(axiosLikeError.response.data.message);
                    }
                    throw error_4;
                case 3: return [2 /*return*/];
            }
        });
    }); },
};
exports.default = strategyApiService;
